import { useMutation } from "@tanstack/react-query";
import {
  createSofiaPurchase,
  postSofiaListingImages,
  postSofiaListingImagesCancel,
  postSofiaListingImagesUse,
  postShareCredit,
} from "./api";

const delay = (ms) =>
  new Promise(resolve => setTimeout(resolve, ms));

// Purchase Sofia credits (top up)
export const useCreateSofiaPurchase = () => {
  return useMutation({
    mutationFn: (data) => createSofiaPurchase(data),
  });
};

// Post sofia listing images
export const usePostSofiaListingImages = () => {
  return useMutation({
    mutationFn: async ({ slug, data }) => {
      const response = await postSofiaListingImages(slug, data);
      
      await delay(5000);

      return response;
    },
  });
};

// Post sofia listing images cancel
export const usePostSofiaListingImagesCancel = () => {
  return useMutation({
    mutationFn: ({ slug }) => postSofiaListingImagesCancel(slug),
  });
};

// Post sofia listing images use
export const usePostSofiaListingImagesUse = () => {
  return useMutation({
    mutationFn: ({ slug }) => postSofiaListingImagesUse(slug),
  });
};

// Post share credit
export const usePostShareCredit = () => {
  return useMutation({
    mutationFn: ({data}) => postShareCredit(data),
  });
};
